
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick } from 'vue'
import { init, EChartsOption } from 'echarts'
import i18n from "@/locales/index";
const _t = i18n.global.t;
export default defineComponent({
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        id: {
            type: String,
            default: 'echartsLineRIceComponents'
        },
        width: {
            type: String,
            default: '394px',
            required: true
        },
        height: {
            type: String,
            default: '200px',
            required: true
        },
        dataY: {
            type: Array,
            default: '',
        },
        dataX: {
            type: Array,
            default: '',
        },
    },
    setup(props) {

        const initChart = () => {
            const echartsLineRIceEcharts = init(document.getElementById(props.id) as HTMLDivElement)

            echartsLineRIceEcharts.setOption({
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params: any) {
                        let index = params[0].dataIndex
                        return `${props.dataX[index]}` + '<br/>' + `${props.dataY[index]}` + _t('public.rice')
                    },
                },
                xAxis: {
                    show: false,
                    type: 'category',
                    boundaryGap: false,
                    data: props.dataX
                },
                yAxis: {
                    show: false,
                    type: 'value'
                },
                series: [
                    {
                        data: props.dataY,
                        type: 'line',
                        lineStyle: {
                            color: '#1890FF'
                        },
                        areaStyle: {
                            normal: {
                                color: {
                                    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0, color: 'rgba(58,132,255, 0.8)' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                        }
                                    ],
                                    global: false // 缺省为 false
                                },
                            }
                        }
                    }
                ]
            } as EChartsOption)
        }

        onMounted(() => {
            setTimeout(() => {
                initChart()
            }, 500)
        })

        onBeforeUnmount(() => {

        })

        onActivated(() => {

        })

        onDeactivated(() => {

        })

        return {

        }
    }
})
